import React from "react";
import DeputySarpanchimg  from "../asstes/gallery/DeputySarpanch.jpeg";
import sarpanchImg from "../asstes/gallery/sarpnch.jpeg";
import gramsevakImg from "../asstes/gallery/gramsevak.jpeg";
import { useLanguage } from '../context/LanguageContext';

const defaultAvatar =
  "https://cdn-icons-png.flaticon.com/512/847/847969.png";

const samitiData = [
  {
    title: { marathi: "ग्रामपंचायत समिती", english: "Gram Panchayat Committee" },
    members: [
      { no: 1, name: { marathi: "अलिशा अशोक कोळी", english: "Alisha Ashok Koli" }, role: { marathi: "सरपंच", english: "Sarpanch" }, photo: sarpanchImg },
      { no: 2, name: { marathi: "अनिता महावीर पाटील", english: "Anita Mahavir Patil" }, role: { marathi: "उपसरपंच", english: "Upasarpanch" }, photo: DeputySarpanchimg },
      { no: 3, name: { marathi: "अलिशा सुनील कदम", english: "Alisha Sunil Kadam" }, role: { marathi: "ग्रामविकास अधिकारी", english: "Gram Vikas Adhikari" }, photo: gramsevakImg },
      { no: 4, name: { marathi: "सुधाकर मंगळा पाटील", english: "Sudhakar Mangla Patil" }, role: { marathi: "ग्रामपंचायत सदस्य", english: "Gram Panchayat Member" } },
      { no: 5, name: { marathi: "अजिंक्य अमर पाटील", english: "Ajinkya Amar Patil" }, role: { marathi: "ग्रामपंचायत सदस्य", english: "Gram Panchayat Member" } },
      { no: 6, name: { marathi: "अनिक रमेश कांबळे", english: "Anik Ramesh Kamble" }, role: { marathi: "ग्रामपंचायत सदस्य", english: "Gram Panchayat Member" } },
      { no: 7, name: { marathi: "सुनीता अर्जुन जाधव", english: "Sunita Arjun Jadhav" }, role: { marathi: "महिला सदस्य", english: "Female Member" } },
      { no: 8, name: { marathi: "विभा सचिन कडवे", english: "Vibha Sachin Kadve" }, role: { marathi: "महिला सदस्य", english: "Female Member" } },
      { no: 9, name: { marathi: "विद्या प्रशांत शेलार", english: "Vidya Prashant Shelar" }, role: { marathi: "महिला सदस्य", english: "Female Member" } },
      { no: 10, name: { marathi: "रचना दीपक पाटील", english: "Rachana Deepak Patil" }, role: { marathi: "महिला सदस्य", english: "Female Member" } },
      { no: 11, name: { marathi: "निशा अशोक महाजन", english: "Nisha Ashok Mahajan" }, role: { marathi: "महिला सदस्य", english: "Female Member" } },
      { no: 12, name: { marathi: "सुशिला भास्कर कोळी", english: "Sushila Bhaskar Koli" }, role: { marathi: "महिला सदस्य", english: "Female Member" } },
      { no: 13, name: { marathi: "अपर्णा शंकर कांबळे", english: "Aparna Shankar Kamble" }, role: { marathi: "महिला सदस्य", english: "Female Member" } },
      { no: 14, name: { marathi: "अलिना महावीर पाटील", english: "Alina Mahavir Patil" }, role: { marathi: "महिला सदस्य", english: "Female Member" } },
    ],
  },
  {
    title: { marathi: "ग्राम आरोग्य, पोषण, पाणीपुरवठा व स्वच्छता समिती", english: "Village Health, Nutrition, Water Supply & Sanitation Committee" },
    members: [],
  },
  {
    title: { marathi: "ग्रामविकास समिती", english: "Village Development Committee" },
    members: [],
  },
  {
    title: { marathi: "संयुक्त वन व्यवस्थापन समिती", english: "Joint Forest Management Committee" },
    members: [],
  },
  {
    title: { marathi: "ग्राम बाल संरक्षण समिती", english: "Village Child Protection Committee" },
    members: [],
  },
  {
    title: { marathi: "सामाजिक लेखापरीक्षण समिती", english: "Social Audit Committee" },
    members: [],
  },
];

const GramPanchayatSamiti = () => {
  const { language } = useLanguage();

  return (
    <div className="bg-gray-50 min-h-screen py-10 px-4 md:px-12 space-y-10">

      {samitiData.map((samiti, index) => (
        <div
          key={index}
          className="bg-white rounded-xl shadow-md p-6"
        >
          {/* Title */}
          <h2 className="flex items-center gap-2 text-xl md:text-2xl font-semibold text-indigo-700 mb-4">
            <span className="text-blue-500">👤</span>
            {samiti.title[language] || samiti.title.marathi}
          </h2>

          {/* Table Header */}
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="border-b-2 border-blue-500 text-left text-sm md:text-base">
                  <th className="py-2 px-2 w-16">{language === 'marathi' ? 'अ. नं' : 'Sr. No'}</th>
                  <th className="py-2 px-2 w-20">{language === 'marathi' ? 'फोटो' : 'Photo'}</th>
                  <th className="py-2 px-2">{language === 'marathi' ? 'नाव' : 'Name'}</th>
                  <th className="py-2 px-2">{language === 'marathi' ? 'हुद्दा' : 'Role'}</th>
                </tr>
              </thead>

              <tbody>
                {samiti.members.length > 0 ? (
                  samiti.members.map((m) => (
                    <tr key={m.no} className="border-b text-sm md:text-base">
                      <td className="py-2 px-2">{m.no}</td>
                      <td className="py-2 px-2">
                        <img
                          src={m.photo || defaultAvatar}
                          alt={m.name[language] || m.name.marathi}
                          className="w-10 h-10 rounded-full object-cover"
                        />
                      </td>
                      <td className="py-2 px-2">{m.name[language] || m.name.marathi}</td>
                      <td className="py-2 px-2">{m.role[language] || m.role.marathi}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="4"
                      className="text-center py-4 text-gray-500"
                    >
                      {language === 'marathi' ? 'माहिती उपलब्ध नाही' : 'Information not available'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GramPanchayatSamiti;
